import Icon from "../common/Icon";
import { Button } from "../ui/button";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { cn } from "@/lib/utils";

export type FilterOption = {
  value: string;
  label: string;
  subOptions?: { value: string; label: string }[];
};

interface FilterSelectionProps {
  options: FilterOption[];
  value: string;
  onChange: (value: string | null) => void;
  className?: string;
  onSubOptionSelect?: (subValue: string) => void; // Add this prop
}
export default function InsightsFilterSelectionForJob({
  options,
  value,
  onChange,
  className,
  onSubOptionSelect,
}: FilterSelectionProps) {
  const handleValueChange = (newValue: string) => {
    const parentOption = options.find((opt) =>
      opt.subOptions?.some((sub) => sub.value === newValue)
    );

    if (parentOption) {
      // For suboptions, set the suboption value instead of parent value
      onChange(newValue);
      onSubOptionSelect?.(newValue);
    } else {
      // For main options or clearing
      onChange(newValue === value ? null : newValue);
      onSubOptionSelect?.(""); // Clear suboption when selecting main option
    }
  };
  return (
    <Select value={value || ""} onValueChange={handleValueChange}>
      <SelectTrigger
        className={cn(
          "flex h-12 w-auto items-center justify-center gap-2 rounded-none border-brand-border px-3 font-mono text-[11px] uppercase tracking-[0.22em] text-brand-text",
          className
        )}
        aria-label="Select view type"
      >
        <Icon name="filterStyle" size={16} />
        <SelectValue placeholder="Select view" />
      </SelectTrigger>
      <SelectContent align="end">
        {options.map((option) =>
          option.subOptions ? (
            <SelectGroup key={option.value}>
              <SelectLabel
                className={cn(
                  "pl-3 text-left text-[14px] font-medium text-brand-text"
                )}
              >
                {option.label}
              </SelectLabel>
              {option.subOptions.map((subOption) => (
                <SelectItem
                  key={subOption.value}
                  value={subOption.value}
                  className={cn(
                    "pl-6 text-left text-[14px] text-brand-text"
                  )}
                >
                  {subOption.label}
                </SelectItem>
              ))}
            </SelectGroup>
          ) : (
            <SelectItem
              key={option.value}
              value={option.value}
              className="pl-3 text-left text-[14px] text-brand-text hover:bg-transparent focus:bg-transparent data-[highlighted]:bg-transparent"
            >
              {option.label}
            </SelectItem>
          )
        )}
        <Button
          variant="outline"
          className="mt-4 w-full"
          onClick={() => {
            onChange(null);
            onSubOptionSelect?.(""); // Clear suboption when clicking clear button
          }}
        >
          Clear
        </Button>
      </SelectContent>
    </Select>
  );
}
